import React, { Component } from "react";
import { connect } from "react-redux";
import FormUnavailable from "./pages/formUnavailablePage";
import Connector from "./utils/api/Connector";
import Wait from "@react/react-spectrum/Wait";
import RenewalPage from "./pages/renewalPage";
import { setCOCValidateRegion } from "./storeManagement/action";
import { checkCOCValidationRequired } from "./utils/utils";
import {
  setGeoPolData,
  setCountryStateMappingData,
} from "../actions/commonActions";
import AppErrorPage from "../components/errors/AppErrorPage";
import {
  isUnprocessableEntityError,
  normalizeApiErrorMessages,
} from "../components/errors";
import { isRestrictedSanctionCountry } from "../utils/restrictedSanctionCountry";
// TODO(sanctions-ru-by): RU/BY full-page block — controlled by SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedSanctionPartnerPage from "../components/RestrictedSanctionPartnerPage";
import { getGeoPolData } from "../getGeoPolDataApi";
import { getCountryStateMappingData } from "../getCountryStateMappingDataApi";

class RenewalApp extends Component {
  constructor(props) {
    super(props);
    this.connector = new Connector();
  }

  state = {
    isLoading: true,
  };

  refreshApp = () => {
    this.setState({ isLoading: true });
    this.connector.searchEmail(this.onSearchComplete, { context: "Renewal" });
  };

  componentDidMount() {
    this.refreshApp();
    getGeoPolData(this.props.setGeoPolDataAction);
  }

  onSearchComplete = async (data) => {
    const cntryData = await getCountryStateMappingData();
    if (cntryData && Object.keys(cntryData)?.length > 0) {
      this.props.setCountryStateMappingDataAction(cntryData);
      this.setState({ data: data });
      this.connector.getCOCRegion(this.onGetCOCRegionComplete);
    }
  };

  onGetCOCRegionComplete = (data) => {
    this.setState({ isLoading: false });
    if (data["coc-region"]) {
      this.props.setCOCValidateRegion(
        checkCOCValidationRequired(
          this.state.data.partnerInfo?.billingCountry,
          "Renewal",
          this.state.data.partnerInfo?.level,
          data["coc-region"]
        )
      );
    }
  };

  //ask secondary contact can renew
  render() {
    return (
      <div>
        {this.props.isSaving ? (
          <div className="overlay">
            <Wait size="L" centered />
            <span className="saving-Text">Saving</span>
          </div>
        ) : null}
        {this.state.isLoading ||
        !Object.keys(this.props.geoPolData || {}).length ? (
          <Wait size="L" centered />
        ) : this.state.data.isError ? (
          isUnprocessableEntityError(this.state.data) ? (
            <AppErrorPage
              title="Unable to load this page"
              errorPayload={this.state.data}
              messages={normalizeApiErrorMessages(this.state.data)}
            />
          ) : this.state.data.errorCode === "41004" ||
            this.state.data.errorCode === "40301" ||
            this.state.data.message === "Unauthorized access" ? (
            <FormUnavailable app="renewal" searchData={this.state.data} />
          ) : (
            <AppErrorPage
              title="Unable to load this page"
              errorPayload={this.state.data}
              messages={normalizeApiErrorMessages(this.state.data)}
            />
          )
        ) : isRestrictedSanctionCountry(
            this.state.data?.partnerInfo?.billingCountry,
          ) ? (
          <RestrictedSanctionPartnerPage />
        ) : this.state.data.contactInfo.mainContactType === "Primary" ||
          this.state.data.contactInfo.mainContactType === "Secondary" ? (
          <RenewalPage
            partnerData={this.state.data}
            connector={this.connector}
          />
        ) : (
          <FormUnavailable app="renewal" searchData={this.state.data} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  geoPolData: state.common.geoPolData,
});

const mapDispatchToProps = (dispatch) => ({
  setCOCValidateRegion: (bool) => dispatch(setCOCValidateRegion(bool)),
  setGeoPolDataAction: (e) => dispatch(setGeoPolData(e)),
  setCountryStateMappingDataAction: (e) =>
    dispatch(setCountryStateMappingData(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenewalApp);
